/* eslint-disable indent */
import { useSelector } from 'react-redux';
import {
  projectTotalsSelector,
  getRegionalCarpetInstallPrice,
} from '../../selectors/pricing';
import { scheduleMeasureUrlSelector } from '../../selectors/scheduleMeasureUrl';

const useConfiguratorAdditionalDetails = () => {
  const measures = useSelector((state) => state.measures);
  const steps = useSelector((state) => state.steps);
  const totalAmounts = useSelector(projectTotalsSelector);
  const hdmsDetails = useSelector(scheduleMeasureUrlSelector);
  const regionalInstallPrice = useSelector(getRegionalCarpetInstallPrice);

  return ({
    measures,
    steps,
    totalAmounts,
    hdmsDetails,
    regionalInstallPrice,
  });
};

export default useConfiguratorAdditionalDetails;
